<template>
  <div class="dialog-wrap">
    <el-dialog title="课程分类编辑" :close-on-click-modal="false" :visible.sync="dialogVisible" @close="handleClose" width="480px">
      <el-form class="form" :model="dataForm" :rules="rules" ref="dataForm" label-width="80px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="分类描述" prop="description">
          <el-input v-model="dataForm.description" placeholder="请输入分类描述"></el-input>
        </el-form-item>
        <!--      <el-form-item label="分类图标" prop="icon">
          <el-upload
            class="avatar-uploader"
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="handleBeforeUpload">
            <img v-if="dataForm.icon" :src="dataForm.icon" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="请输入排序值，纯数字"></el-input>
        </el-form-item>
        <div class="form-item-wrap">
          <el-form-item label="在线状态" prop="status">
            <el-switch v-model="dataForm.status"></el-switch>
          </el-form-item>
          <!--     <el-form-item label="客户端菜单状态" prop="menu_status" label-width="150px">
            <el-switch v-model="dataForm.menu_status"></el-switch>
          </el-form-item> -->
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { readCategoryUpdate } from '@/api/read'
import { imgUploadUrl, uploadHeaders } from '@/config/index'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {
        icon: ''
      },
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      rules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        description: [{ required: false, message: '请输入分类描述', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }],
        menu_status: [{ required: false, message: '请设置客户端菜单状态', trigger: 'change' }],
        icon: [{ required: true, message: '请上传分类图标', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.dataForm = val
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            name: this.dataForm.name,
            icon: this.dataForm.icon,
            direction: this.dataForm.direction,
            type: this.dataForm.type,
            sort: this.dataForm.sort,
            menu_status: this.dataForm.menu_status ? 1 : 0,
            status: this.dataForm.status ? 1 : 0
          }
          readCategoryUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.icon = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;

    .avatar-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 128px;
      height: 128px;
      line-height: 128px;
      text-align: center;
    }
    .avatar {
      display: block;
      width: 128px;
      height: 128px;
      object-fit: cover;
    }

    .form-item-wrap {
      display: flex;
    }
  }
}
</style>
